import React from "react";
import classes from "./HelpAndFeedback.module.css";
import { Form, Button } from "react-bootstrap";

const FormField = (props) => {
  return (
    <div className={classes.form}>
      <form onSubmit={(e) => props.formSubmit(e, props.title)}>
        <Form.Group>
          <Form.Text className="text-muted" style={{ fontSize: "18px" }}>
            {`Kindly share your queries/feedback. Our team will get back to you as soon as possible. You can email us directly at `}
            <a href="mailto:support@foxmatrix.com">support@foxmatrix.com</a>
            {` or call us on `}
            <a href="tel:+917007965311">7007965311</a>.{" "}
          </Form.Text>
          <br />
          <textarea
            placeholder="Write your query/feedback here..."
            onChange={props.handleForm}
            autoFocus={true}
            name="data"
            form="usrform"
          />
          <div style={{ color: "red", height: "20px" }}>
            {props.error !== "" ? props.error : ""}
          </div>
        </Form.Group>

        <div style={{ textAlign: "center" }}>
          <Button className={classes.button} type="submit" variant="warning">
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FormField;
